import { atualizarLocalizacaoProfissionalGestaoVaga } from "../../../servicos/gestaoVagaLocalizacao.js"

/**
 * Lê GPS fresco e recarrega o hub com as mesmas coordenadas (evita cache na segunda leitura).
 * @param {(opts?: { silencioso?: boolean, geo?: { latitude: number, longitude: number } }) => Promise<void>} recarregarHub
 */
export async function atualizarGeoERecarregarGestaoVagaHub(recarregarHub) {
	const geo = await atualizarLocalizacaoProfissionalGestaoVaga()
	if (!geo) {
		return { ok: false, geo: null }
	}
	await recarregarHub({ silencioso: true, geo })
	return { ok: true, geo }
}
